__turbopack_context__.v({
  "notification": "Notifications-module__qN-DZG__notification",
  "openNotification": "Notifications-module__qN-DZG__openNotification",
  "root": "Notifications-module__qN-DZG__root",
});
